// extracted by mini-css-extract-plugin
export default {"product-features":"ProductFeatures_product-features__tGw+7","feature":"ProductFeatures_feature__D7kdO","icon":"ProductFeatures_icon__-Pn4W"};